import { useState } from 'react'
import { heapEvent } from '@equipmentshare/heaper'

import {
	EuiButton,
	EuiButtonEmpty,
	EuiModalBody,
	EuiModalFooter,
} from '@equipmentshare/ds2'

import ProductClassForm, { ProductClassFormState } from '../../ProductClassForm'
import useUpdateProductClassHandler from '../../../effects/updateProductClass'
import validateForm from '../../ProductClassForm/helpers/validateForm'

export type EditProductClassModalProps<T extends { id: string, catClass: string, categoryName: string, classification: string }> = {
	onCancel: () => void,
	onSuccess: () => void,
	productClass: T,
}

export default function EditProductClassModal<T extends { id: string, catClass: string, categoryName: string, classification: string }>( { onCancel, onSuccess, productClass }: EditProductClassModalProps<T> ) {
	const [ formState, setFormState ] = useState<ProductClassFormState>( {
		catClass: productClass.catClass,
		categoryName: productClass.categoryName,
		classification: productClass.classification,
		validation: {
			catClass: { isInvalid: false },
			categoryName: { isInvalid: false },
			classification: { isInvalid: false },
		},
	} )
	const [ isSaving, setIsSaving ] = useState( false )
	const updateProductClass = useUpdateProductClassHandler()

	const handleCancel = () => {
		heapEvent( 'Inventory - Edit Product Class Modal - Click - Cancel', {} )
		onCancel()
	}

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Edit Product Class Modal - Click - Submit', {} )
		setIsSaving( true )

		const { isInvalid, newFormState } = validateForm( formState )
		if ( isInvalid ) {
			setFormState( newFormState )
			setIsSaving( false )
		} else {
			try {
				await updateProductClass(
					productClass.id,
					productClass.catClass === formState.catClass ? undefined : formState.catClass,
					productClass.categoryName === formState.categoryName ? undefined : formState.categoryName,
					productClass.classification === formState.classification ? undefined : formState.classification,
				)
			} catch ( e: unknown ) {
				setIsSaving( false )
			}
			onSuccess()
		}
	}

	return (
		<>
			<EuiModalBody>
				<ProductClassForm
					formState={formState}
					setFormState={setFormState}
				/>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButtonEmpty
					color="text"
					id="cancelBtn"
					onClick={handleCancel}
				>
					Cancel
				</EuiButtonEmpty>
				<EuiButton
					id="submitBtn"
					fill
					isLoading={isSaving}
					onClick={handleSubmit}
				>
					Submit
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
